import React from 'react';
interface RouletteProps {
    size?: number;
}
export const Roulette: React.FC<RouletteProps> = ({ size = 490 }) => {
    return (
        <svg
            className="roulette-2 roulette"
            viewBox={`0 0 ${size} ${size}`}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={size}
            height={size}
        >
            <defs>
                <path
                    id="j"
                    d="M194 0c107.14 0 194 86.86 194 194s-86.86 194-194 194S0 301.14 0 194 86.86 0 194 0Zm0 93c-55.78 0-101 45.22-101 101s45.22 101 101 101 101-45.22 101-101S249.78 93 194 93Z"
                />
                <path
                    id="l"
                    d="M194 0c107.14 0 194 86.86 194 194s-86.86 194-194 194S0 301.14 0 194 86.86 0 194 0Zm0 102a92 92 0 1 0 0 184 92 92 0 0 0 0-184Z"
                />
                <path
                    id="a"
                    d="M311.68 532.6c122 0 220.92-98.91 220.92-220.92 0-122.01-98.91-220.92-220.92-220.92-122.01 0-220.92 98.9-220.92 220.92 0 122 98.9 220.92 220.92 220.92Z"
                />
                <path
                    id="b"
                    d="M312.38 533.3c122 0 220.92-98.91 220.92-220.92 0-122.02-98.91-220.92-220.92-220.92-122.02 0-220.92 98.9-220.92 220.92 0 122 98.9 220.92 220.92 220.92Z"
                />
                <path
                    id="c"
                    d="M311.78 532.7c122.01 0 220.92-98.9 220.92-220.92 0-122-98.9-220.92-220.92-220.92-122 0-220.92 98.91-220.92 220.92 0 122.01 98.91 220.92 220.92 220.92Z"
                />
                <path
                    id="d"
                    d="M312.02 532.94c122.02 0 220.92-98.9 220.92-220.92 0-122-98.9-220.92-220.92-220.92-122 0-220.92 98.91-220.92 220.92 0 122.02 98.91 220.92 220.92 220.92Z"
                />
                <path
                    id="e"
                    d="M311.58 532.5c122.01 0 220.92-98.9 220.92-220.92 0-122-98.9-220.92-220.92-220.92-122 0-220.92 98.91-220.92 220.92 0 122.01 98.91 220.92 220.92 220.92Z"
                />
                <path
                    id="f"
                    d="M311.8 532.72c122.01 0 220.92-98.9 220.92-220.92 0-122-98.9-220.92-220.92-220.92-122 0-220.92 98.91-220.92 220.92 0 122.01 98.91 220.92 220.92 220.92Z"
                />
                <path
                    id="g"
                    d="M312 532.92c122.01 0 220.92-98.9 220.92-220.92 0-122.01-98.9-220.92-220.92-220.92-122.01 0-220.92 98.9-220.92 220.92 0 122.01 98.9 220.92 220.92 220.92Z"
                />
                <path id="h" d="M312 533c122.05 0 221-98.95 221-221S434.05 91 312 91 91 189.95 91 312s98.95 221 221 221Z" />
                <path
                    id="v"
                    d="M184 0c101.62 0 184 82.38 184 184s-82.38 184-184 184S0 285.62 0 184 82.38 0 184 0Zm0 92a92 92 0 1 0 0 184 92 92 0 0 0 0-184Z"
                />
                <path
                    id="y"
                    d="M199.38 331.21c-1.07 0-2-.22-2.8-.67a4.76 4.76 0 0 1-1.87-1.87 5.65 5.65 0 0 1-.67-2.8v-4.32c0-1.06.22-2 .67-2.8a4.76 4.76 0 0 1 1.87-1.87c.8-.44 1.73-.67 2.8-.67 1.07 0 2 .23 2.8.67.8.45 1.42 1.07 1.87 1.87.45.8.67 1.74.67 2.8v4.32c0 1.07-.22 2-.67 2.8a4.76 4.76 0 0 1-1.87 1.87c-.8.45-1.73.67-2.8.67Zm0-2.58a2.52 2.52 0 0 0 2.56-2.56v-4.74a2.52 2.52 0 0 0-2.56-2.56 2.52 2.52 0 0 0-2.56 2.56v4.74a2.52 2.52 0 0 0 2.56 2.56Z"
                />
                <path
                    id="A"
                    d="m259.02 292 1.5 2.05 1.97 10.45-2.52 1.83-1.98-10.45-2.54 1.85 2.11 2.9-2.23 1.63-2.11-2.91-1.04.75-1.5-2.05 1.04-.76-1.31-1.8 2.23-1.63 1.32 1.81 5.06-3.68Zm3.68-5.45 6.73 9.25 1.2-2.93 1.77 2.43-1.23 2.9-2.25 1.63-8.47-11.65 2.25-1.63Z"
                />
                <path id="C" d="m302.57 252.82 4.84-11.84h-6.16v-2.56h9.08v2.56l-4.82 11.84z" />
                <path
                    id="E"
                    d="m319 175.8 11.4 1-1.42-2.83 2.99.26 1.38 2.83-.25 2.77-14.34-1.25.24-2.77Zm-1.2 10.72a5.02 5.02 0 0 1 3.93-4.47l.46 2.69c-.53.1-.96.33-1.29.72a2.26 2.26 0 0 0 3.13 3.24c.48-.38.75-.9.8-1.56.02-.2.01-.4-.03-.59-.04-.19-.1-.37-.19-.55l2.24-1.03 3.39 4.9-.6.14.59-6.65 2.55.22-.79 8.96-2.55-.22-3.12-3.85.76.05a4.38 4.38 0 0 1-2.8 3.16c-.69.24-1.4.33-2.13.26-.9-.08-1.7-.38-2.38-.9a5.04 5.04 0 0 1-1.97-4.52Z"
                />
                <path
                    id="G"
                    d="M319.02 126.07a4.83 4.83 0 0 1-4.36-2.54 5.63 5.63 0 0 1-.66-2.76v-4.18c0-1.14.22-2.11.66-2.94a4.6 4.6 0 0 1 1.86-1.9c.8-.44 1.74-.66 2.82-.66.7 0 1.37.1 2 .3.64.21 1.22.56 1.74 1.06l-1.94 1.94a2.6 2.6 0 0 0-1.8-.76 2.47 2.47 0 0 0-2.24 1.31c-.21.4-.32.8-.32 1.25v2.14l-.46-.5a4.27 4.27 0 0 1 3.12-1.3 4.33 4.33 0 0 1 4.01 2.28c.4.7.6 1.51.6 2.42 0 .9-.24 1.72-.7 2.45a5.1 5.1 0 0 1-4.33 2.39Zm0-2.6a2.27 2.27 0 0 0 1.95-1.11c.21-.34.31-.72.31-1.13a2.27 2.27 0 0 0-1.11-1.95c-.34-.21-.71-.31-1.13-.31-.4 0-.79.1-1.13.3a2.3 2.3 0 0 0-1.13 1.96c0 .4.1.77.3 1.1.2.35.47.62.81.83.34.2.72.3 1.13.3Z"
                />
                <path
                    id="I"
                    d="M291.87 56.33c.8.31 1.56.85 2.24 1.61.63.7 1.04 1.46 1.24 2.29.19.83.16 1.64-.1 2.45-.26.8-.75 1.54-1.47 2.18-.53.48-1.04.8-1.52.97-.48.16-1 .23-1.56.2a27.8 27.8 0 0 1-1.97-.17l-4.25-.5 3.92 4.35-1.9 1.71-6.75-7.5 1.76-1.57 8.02.9c.6.07 1.1.06 1.48-.04.39-.1.7-.25.93-.45.32-.3.55-.63.69-1 .13-.36.16-.72.1-1.1a2.19 2.19 0 0 0-.56-1.05 2.24 2.24 0 0 0-2.2-.74c-.4.08-.73.26-1.02.54l-1.87-2.08a4.87 4.87 0 0 1 2.34-1.23 4.38 4.38 0 0 1 2.45.23Zm-8 8.35-.3.57.91.1-.6-.67Zm-.58-15.89 3.01.92 1.86 2.07-10.7 9.64-1.86-2.07 8.5-7.65-3.04-.9 2.23-2Z"
                />
                <path
                    id="K"
                    d="M230.84 28.9a4.74 4.74 0 0 1-3.69-1.7 4.82 4.82 0 0 1-.99-1.87l2.62-.7c.1.34.25.64.47.88.22.25.48.44.78.58a2.21 2.21 0 0 0 2.05-.1 2.16 2.16 0 0 0 1.13-1.94 2.27 2.27 0 0 0-2.26-2.24c-.51 0-.93.09-1.25.26-.32.17-.56.33-.72.48l-2.3-.7.44-7.66h7.86v2.54h-6.36l.96-.9-.3 4.94-.46-.56c.36-.3.77-.5 1.23-.64a4.65 4.65 0 0 1 3.69.4c.69.41 1.23.96 1.62 1.67a4.9 4.9 0 0 1-.13 4.87 5.2 5.2 0 0 1-4.39 2.38Z"
                />
                <path id="M" d="M161.43 14.4V2.96l-2.7 1.66v-3l2.7-1.62h2.78v14.4h-2.78Zm9.08 0V2.96l-2.7 1.66v-3l2.7-1.62h2.78v14.4h-2.78Z" />
                <path id="O" d="M103.7 28.98v-2.24h-6.26V24.2l4.54-9.62h3.12l-4.54 9.62h3.14v-3.6h2.76v3.6h1.28v2.54h-1.28v2.24z" />
                <path
                    id="Q"
                    d="m39.9 58.94 10.7 9.64-1.85 2.07-8.5-7.66-.58 3.12-2.23-2 .6-3.1 1.87-2.07Zm10.91-8.76c.9.2 1.74.66 2.53 1.38l3.21 2.89c.8.71 1.34 1.5 1.64 2.37.3.87.34 1.75.13 2.64-.2.9-.66 1.74-1.37 2.53-.72.8-1.5 1.34-2.37 1.63-.87.3-1.75.34-2.64.14-.9-.2-1.74-.66-2.53-1.38L46.2 59.5a5.65 5.65 0 0 1-1.64-2.37 4.76 4.76 0 0 1-.13-2.64c.2-.9.66-1.74 1.37-2.53.71-.8 1.5-1.34 2.37-1.63.87-.3 1.75-.34 2.64-.14Zm-1.98 2.75c-.43.13-.8.38-1.13.73a2.52 2.52 0 0 0 .2 3.62l3.52 3.17a2.52 2.52 0 0 0 3.61-.19 2.52 2.52 0 0 0-.19-3.61l-3.52-3.18a2.52 2.52 0 0 0-2.5-.54Z"
                />
                <path
                    id="S"
                    d="M15.41 125.82a5.02 5.02 0 0 1-4.8-3.52l2.64-.7c.14.52.42.93.83 1.22a2.26 2.26 0 0 0 2.96-3.4 2.15 2.15 0 0 0-1.63-.66c-.2 0-.39.03-.58.08-.18.06-.36.14-.54.24l-1.22-2.14 4.58-3.8.2.58h-6.68v-2.56h9v2.56l-3.56 3.44-.02-.76a4.38 4.38 0 0 1 3.4 2.52c.3.66.44 1.36.44 2.1 0 .9-.23 1.72-.69 2.44a5.04 5.04 0 0 1-4.33 2.36Z"
                />
                <path
                    id="U"
                    d="M7.9 176.01a4.83 4.83 0 0 1 4.36 2.53c.44.8.66 1.73.66 2.77v4.18c0 1.14-.22 2.11-.66 2.94a4.6 4.6 0 0 1-1.86 1.9c-.8.44-1.74.66-2.82.66-.7 0-1.37-.1-2-.31a4.86 4.86 0 0 1-1.74-1.05l1.94-1.94a2.6 2.6 0 0 0 3.15.4 2.59 2.59 0 0 0 1.2-2.2v-2.14l.47.5a4.43 4.43 0 0 1-3.12 1.3 4.33 4.33 0 0 1-4.02-2.28 4.92 4.92 0 0 1-.58-2.42c0-.9.23-1.72.69-2.45A5.1 5.1 0 0 1 7.9 176Zm0 2.6a2.27 2.27 0 0 0-1.96 1.11c-.2.34-.3.72-.3 1.13a2.27 2.27 0 0 0 1.11 1.95c.34.21.72.31 1.13.31.41 0 .8-.1 1.13-.3a2.3 2.3 0 0 0 1.13-1.96c0-.4-.1-.77-.3-1.1-.2-.35-.47-.62-.81-.83-.34-.2-.72-.3-1.13-.3Z"
                />
                <path
                    id="W"
                    d="M22.79 254.45v-2.36l6.04-5.36c.45-.4.77-.78.96-1.13.18-.36.28-.69.28-1 0-.43-.1-.82-.27-1.17a2.02 2.02 0 0 0-.76-.8c-.33-.2-.71-.3-1.15-.3a2.24 2.24 0 0 0-2.03 1.14c-.2.35-.29.72-.27 1.12h-2.8c0-.99.21-1.84.65-2.56a4.38 4.38 0 0 1 1.8-1.67c.78-.4 1.68-.6 2.7-.6.95 0 1.79.21 2.53.62.74.41 1.33.98 1.76 1.72.42.73.64 1.58.64 2.55 0 .71-.1 1.3-.3 1.77-.2.47-.5.9-.9 1.3-.39.4-.87.85-1.44 1.35l-3.9 3.42-.22-.6h6.76v2.56H22.79Z"
                />
                <path
                    id="Y"
                    d="M72.11 303.56a5.5 5.5 0 0 1-2.6-.6 4.45 4.45 0 0 1-2.42-4.02c0-.76.17-1.48.52-2.15.34-.68.84-1.23 1.48-1.65l-.06.84a5.99 5.99 0 0 1-1.14-1.5 3.77 3.77 0 0 1-.42-1.78c0-.84.2-1.56.6-2.18a4 4 0 0 1 1.64-1.45c.7-.34 1.5-.51 2.4-.51.9 0 1.71.17 2.4.51a4 4 0 0 1 1.65 1.45c.4.62.6 1.34.6 2.18 0 .66-.14 1.25-.4 1.77a5.36 5.36 0 0 1-1.19 1.53v-.84c.64.4 1.12.94 1.47 1.62a4.73 4.73 0 0 1-.14 4.54 4.53 4.53 0 0 1-1.79 1.64c-.76.4-1.62.6-2.6.6Zm0-2.56a2.3 2.3 0 0 0 1.56-.52c.4-.35.6-.86.6-1.54s-.2-1.19-.6-1.55c-.4-.35-.92-.53-1.56-.53s-1.15.18-1.55.53c-.4.36-.59.87-.59 1.55s.2 1.2.6 1.54c.39.34.9.52 1.54.52Zm0-6.72a2 2 0 0 0 1.27-.39c.33-.25.5-.65.5-1.2 0-.53-.17-.93-.5-1.2-.32-.26-.75-.4-1.27-.4s-.94.14-1.27.4c-.32.27-.49.67-.49 1.2 0 .55.17.95.5 1.2a2 2 0 0 0 1.26.39Z"
                />
                <path id="aa" d="M134.29 330.77v-11.44l-2.7 1.66v-3l2.7-1.62h2.78v14.4z" />
                <path
                    id="ad"
                    d="M127 29c-4.78 0-9.13.42-13.06 1.27a3 3 0 0 1-3.57-2.3v-.03L105.6 4.96a3 3 0 0 1 2.43-3.56C113.42.47 119.74 0 127 0c7.26 0 13.58.47 18.96 1.4a3 3 0 0 1 2.43 3.56l-4.76 22.98a3 3 0 0 1-3.55 2.33h-.02A62.27 62.27 0 0 0 127 29Z"
                />
                <path
                    id="ag"
                    d="M207.42 65.05c-4.77 0-9.12.41-13.05 1.26a3 3 0 0 1-3.56-2.3v-.03l-4.76-22.95a3 3 0 0 1 2.42-3.56c5.38-.93 11.7-1.4 18.94-1.4 7.24.01 13.56.48 18.94 1.42a3 3 0 0 1 2.42 3.56L224.04 64a3 3 0 0 1-3.55 2.32h-.02a62.24 62.24 0 0 0-13.05-1.27Z"
                />
                <path
                    id="aj"
                    d="M235.69 149.96c-4.78 0-9.13.43-13.06 1.27a3 3 0 0 1-3.57-2.33l-4.75-22.92a3 3 0 0 1 2.33-3.55l.1-.02c5.38-.93 11.7-1.4 18.95-1.4s13.56.47 18.94 1.4a3 3 0 0 1 2.43 3.56l-4.75 22.93a3 3 0 0 1-3.54 2.33h-.03a62.3 62.3 0 0 0-13.05-1.27Z"
                />
                <path
                    id="am"
                    d="M190.85 227.08c-4.76 0-9.11.42-13.04 1.27a3 3 0 0 1-3.56-2.3v-.02l-4.74-22.96a3 3 0 0 1 2.42-3.55c5.38-.94 11.7-1.41 18.94-1.42 7.24 0 13.55.46 18.93 1.4a3 3 0 0 1 2.43 3.56L207.47 226a3 3 0 0 1-3.57 2.33 62.15 62.15 0 0 0-13.05-1.26Z"
                />
                <path
                    id="ap"
                    d="M62.9 226.78c-4.77 0-9.12.41-13.05 1.25a3 3 0 0 1-3.56-2.3v-.02l-4.76-22.96a3 3 0 0 1 2.42-3.56 112.1 112.1 0 0 1 18.93-1.39c7.25 0 13.56.48 18.94 1.41a3 3 0 0 1 2.42 3.56l-4.73 22.95a3 3 0 0 1-3.55 2.33h-.02a62.2 62.2 0 0 0-13.04-1.27Z"
                />
                <path
                    id="as"
                    d="M17.7 149.96c-4.78 0-9.14.42-13.07 1.27a3 3 0 0 1-3.56-2.33l-4.76-22.93a3 3 0 0 1 2.43-3.56c5.38-.93 11.7-1.4 18.95-1.4s13.57.47 18.95 1.4a3 3 0 0 1 2.42 3.57l-4.74 22.92a3 3 0 0 1-3.55 2.33h-.02a62.32 62.32 0 0 0-13.06-1.27Z"
                />
                <path
                    id="av"
                    d="M45.2 65.17c-4.77 0-9.12.43-13.05 1.28a3 3 0 0 1-3.57-2.33l-4.73-22.94a3 3 0 0 1 2.42-3.56c5.38-.94 11.7-1.4 18.95-1.41 7.24 0 13.55.46 18.93 1.39a3 3 0 0 1 2.43 3.56L61.8 64.11a3 3 0 0 1-3.56 2.32 62.2 62.2 0 0 0-13.05-1.26Z"
                />
                <path
                    id="ay"
                    d="M169.4 36.6c-4.77 0-9.12.42-13.05 1.26a3 3 0 0 1-3.56-2.32l-4.77-23a3 3 0 0 1 2.43-3.56 112 112 0 0 1 18.93-1.38c7.25 0 13.57.48 18.95 1.41a3 3 0 0 1 2.42 3.56l-4.73 22.99a3 3 0 0 1-3.54 2.33h-.03a62.16 62.16 0 0 0-13.04-1.28Z"
                />
                <path
                    id="aB"
                    d="M228.83 102.33c-4.79 0-9.15.42-13.08 1.26a3 3 0 0 1-3.56-2.32l-4.77-22.95a3 3 0 0 1 2.42-3.57c5.39-.93 11.71-1.39 18.97-1.38 7.26 0 13.58.47 18.97 1.4a3 3 0 0 1 2.43 3.57l-4.75 22.94a3 3 0 0 1-3.54 2.33h-.03a62.42 62.42 0 0 0-13.06-1.28Z"
                />
                <path
                    id="aE"
                    d="M220.2 190.24c-4.78 0-9.14.43-13.07 1.27a3 3 0 0 1-3.57-2.3v-.02l-4.74-22.95a3 3 0 0 1 2.34-3.54l.08-.02c5.4-.94 11.72-1.41 18.98-1.42 7.25 0 13.57.46 18.95 1.39a3 3 0 0 1 2.43 3.56l-4.77 22.96a3 3 0 0 1-3.55 2.33h-.02a62.31 62.31 0 0 0-13.07-1.26Z"
                />
                <path
                    id="aH"
                    d="M147.7 243.24c-4.76 0-9.1.43-13.03 1.28a3 3 0 0 1-3.58-2.33l-4.74-23a3 3 0 0 1 2.43-3.55c5.38-.94 11.7-1.4 18.94-1.41 7.24 0 13.55.46 18.93 1.4a3 3 0 0 1 2.42 3.56l-4.76 23a3 3 0 0 1-3.56 2.32 62.07 62.07 0 0 0-13.05-1.27Z"
                />
                <path
                    id="aK"
                    d="M102.73 243.24c-4.77 0-9.12.42-13.05 1.27a3 3 0 0 1-3.56-2.33l-4.76-23a3 3 0 0 1 2.33-3.54l.09-.02c5.38-.93 11.69-1.4 18.93-1.4 7.25.01 13.56.48 18.94 1.42a3 3 0 0 1 2.43 3.56l-4.74 22.99a3 3 0 0 1-3.55 2.33h-.02a62.1 62.1 0 0 0-13.04-1.28Z"
                />
                <path
                    id="aN"
                    d="M30.44 190.28c-4.78 0-9.13.42-13.07 1.26a3 3 0 0 1-3.56-2.33l-4.78-22.96a3 3 0 0 1 2.43-3.56c5.39-.93 11.7-1.39 18.96-1.38 7.26 0 13.58.48 18.97 1.42a3 3 0 0 1 2.42 3.56l-4.73 22.95a3 3 0 0 1-3.57 2.32 62.38 62.38 0 0 0-13.07-1.28Z"
                />
                <path
                    id="aQ"
                    d="M21.51 102.2c-4.78 0-9.13.42-13.07 1.27a3 3 0 0 1-3.56-2.3v-.02L.12 78.2a3 3 0 0 1 2.43-3.57c5.39-.93 11.71-1.4 18.97-1.4 7.26-.01 13.58.45 18.96 1.38a3 3 0 0 1 2.43 3.56l-4.77 22.95a3 3 0 0 1-3.56 2.33 62.37 62.37 0 0 0-13.08-1.26Z"
                />
                <path
                    id="aT"
                    d="M81.36 36.6c-4.76.01-9.11.44-13.04 1.28a3 3 0 0 1-3.56-2.3l-.01-.02-4.73-22.99a3 3 0 0 1 2.42-3.56c5.38-.93 11.7-1.4 18.95-1.41a112 112 0 0 1 18.93 1.38 3 3 0 0 1 2.43 3.57l-4.77 22.99a3 3 0 0 1-3.56 2.32 62.1 62.1 0 0 0-13.06-1.25Z"
                />
                <filter id="i" width="138.9%" height="138.9%" x="-19.5%" y="-19.5%" filterUnits="objectBoundingBox">
                    <feMorphology in="SourceAlpha" operator="dilate" radius=".5" result="shadowSpreadOuter1" />
                    <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="ac" width="440.9%" height="583.9%" x="-170.5%" y="-241.9%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="ae" width="359.1%" height="467.7%" x="-129.5%" y="-183.9%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="af" width="441.3%" height="584.3%" x="-170.6%" y="-242.1%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="ah" width="359.4%" height="468%" x="-129.7%" y="-184%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="ai" width="441.1%" height="584.7%" x="-170.5%" y="-242.3%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="ak" width="359.2%" height="468.3%" x="-129.6%" y="-184.2%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="al" width="441.3%" height="584.2%" x="-170.7%" y="-242.1%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="an" width="359.4%" height="468%" x="-129.7%" y="-184%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="ao" width="441.4%" height="584.2%" x="-170.7%" y="-242.1%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="aq" width="359.4%" height="468%" x="-129.7%" y="-184%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="ar" width="441.1%" height="584.7%" x="-170.5%" y="-242.3%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="at" width="359.2%" height="468.3%" x="-129.6%" y="-184.2%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="au" width="441.3%" height="584.3%" x="-170.6%" y="-242.1%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="aw" width="359.4%" height="468.1%" x="-129.7%" y="-184%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="ax" width="441.3%" height="583.5%" x="-170.6%" y="-241.8%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="az" width="359.4%" height="467.5%" x="-129.7%" y="-183.7%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="aA" width="440.8%" height="584.3%" x="-170.4%" y="-242.1%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="aC" width="359%" height="468.1%" x="-129.5%" y="-184%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="aD" width="440.9%" height="584.1%" x="-170.4%" y="-242.1%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="aF" width="359.1%" height="467.9%" x="-129.5%" y="-184%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="aG" width="441.4%" height="583.5%" x="-170.7%" y="-241.8%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="aI" width="359.4%" height="467.5%" x="-129.7%" y="-183.7%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="aJ" width="441.4%" height="583.5%" x="-170.7%" y="-241.8%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="aL" width="359.4%" height="467.5%" x="-129.7%" y="-183.7%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="aM" width="440.9%" height="584.1%" x="-170.4%" y="-242%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="aO" width="359.1%" height="467.9%" x="-129.5%" y="-184%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="aP" width="440.8%" height="584.3%" x="-170.4%" y="-242.2%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="aR" width="359%" height="468.1%" x="-129.5%" y="-184%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <filter id="aS" width="441.3%" height="583.5%" x="-170.6%" y="-241.8%" filterUnits="objectBoundingBox">
                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="25" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                </filter>
                <filter id="aU" width="359.4%" height="467.5%" x="-129.7%" y="-183.7%" filterUnits="objectBoundingBox">
                    <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5.5" />
                    <feOffset dy="3" in="shadowBlurInner1" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1" />
                    <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                </filter>
                <linearGradient id="z" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.74%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#C2FFBE" />
                </linearGradient>
                <linearGradient id="B" x1="68.33%" x2="35.58%" y1="65.87%" y2="24.01%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#B0B0B0" />
                </linearGradient>
                <linearGradient id="D" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFC1C1" />
                </linearGradient>
                <linearGradient id="F" x1="100%" x2="0%" y1="50%" y2="50%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#B0B0B0" />
                </linearGradient>
                <linearGradient id="H" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFC1C1" />
                </linearGradient>
                <linearGradient id="J" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#B0B0B0" />
                </linearGradient>
                <linearGradient id="L" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFC1C1" />
                </linearGradient>
                <linearGradient id="N" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#B0B0B0" />
                </linearGradient>
                <linearGradient id="P" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFC1C1" />
                </linearGradient>
                <linearGradient id="R" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#B0B0B0" />
                </linearGradient>
                <linearGradient id="T" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFC1C1" />
                </linearGradient>
                <linearGradient id="V" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#B0B0B0" />
                </linearGradient>
                <linearGradient id="X" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFC1C1" />
                </linearGradient>
                <linearGradient id="Z" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#B0B0B0" />
                </linearGradient>
                <linearGradient id="ab" x1="47.11%" x2="47.11%" y1="19.74%" y2="79.85%">
                    <stop offset="0%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFC1C1" />
                </linearGradient>
                <mask id="n" width="441.84" height="441.84" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                    <use xlinkHref="#a" />
                </mask>
                <mask id="o" width="441.84" height="441.84" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                    <use xlinkHref="#b" />
                </mask>
                <mask id="p" width="441.84" height="441.84" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                    <use xlinkHref="#c" />
                </mask>
                <mask id="q" width="441.84" height="441.84" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                    <use xlinkHref="#d" />
                </mask>
                <mask id="r" width="441.84" height="441.84" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                    <use xlinkHref="#e" />
                </mask>
                <mask id="s" width="441.84" height="441.84" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                    <use xlinkHref="#f" />
                </mask>
                <mask id="t" width="441.84" height="441.84" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                    <use xlinkHref="#g" />
                </mask>
                <mask id="u" width="442" height="442" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                    <use xlinkHref="#h" />
                </mask>
                <radialGradient id="k" cx="50%" cy="50.67%" r="49.34%" fx="50%" fy="50.67%">
                    <stop offset="0%" stopColor="#0F161B" />
                    <stop offset="100%" stopColor="#3C4C55" stopOpacity=".7" />
                </radialGradient>
                <radialGradient id="x" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                    <stop offset="0%" stopOpacity="0" />
                    <stop offset="71.38%" stopColor="#FFF" stopOpacity=".13" />
                    <stop offset="89.61%" stopOpacity=".18" />
                    <stop offset="100%" stopOpacity=".3" />
                </radialGradient>
            </defs>
            <g fill="none" fillRule="evenodd">
                <g transform="translate(51 51)">
                    <use xlinkHref="#j" fill="#000" filter="url(#i)" />
                    <use xlinkHref="#j" fill="url(#k)" fillOpacity=".6" stroke="#FFF" strokeOpacity=".1" />
                </g>
                <g transform="translate(51 51)">
                    <mask id="m" fill="#fff">
                        <use xlinkHref="#l" />
                    </mask>
                    <use xlinkHref="#l" fill="#000" fillOpacity="0" />
                    <g mask="url(#m)" opacity=".1">
                        <g transform="translate(-118 -118)">
                            <use
                                xlinkHref="#a"
                                stroke="#FFF"
                                strokeDasharray="92.52571105957031,2208"
                                strokeWidth="441.6"
                                mask="url(#n)"
                                transform="rotate(24 311.68 311.68)"
                            />
                            <path d="M147.82 459.82c81.65 90.68 221.33 98 312 16.36 90.68-81.65 98-221.33 16.36-312-81.65-90.68-221.33-98-312-16.36-90.68 81.65-98 221.33-16.36 312Z" />
                            <use
                                xlinkHref="#b"
                                stroke="#FFF"
                                strokeDasharray="92.52571105957031,2208"
                                strokeWidth="441.6"
                                mask="url(#o)"
                                transform="rotate(72 312.38 312.38)"
                            />
                            <path d="M92.1 288.71c-12.76 121.34 75.27 230.05 196.61 242.8 121.34 12.76 230.05-75.27 242.8-196.62 12.76-121.34-75.27-230.04-196.62-242.8-121.34-12.75-230.04 75.28-242.8 196.62Z" />
                            <use
                                xlinkHref="#c"
                                stroke="#FFF"
                                strokeDasharray="92.52571105957031,2208"
                                strokeWidth="441.6"
                                mask="url(#p)"
                                transform="rotate(120 311.78 311.78)"
                            />
                            <path d="M181.73 132.85c-98.71 71.72-120.6 209.88-48.88 308.59 71.72 98.7 209.88 120.59 308.59 48.87 98.7-71.72 120.59-209.87 48.87-308.58-71.72-98.71-209.87-120.6-308.58-48.88Z" />
                            <use
                                xlinkHref="#d"
                                stroke="#FFF"
                                strokeDasharray="92.52571105957031,2208"
                                strokeWidth="441.6"
                                mask="url(#q)"
                                transform="rotate(168 312.02 312.02)"
                            />
                            <path d="M357.96 95.93C238.6 70.56 121.3 146.75 95.93 266.1 70.56 385.44 146.75 502.75 266.1 528.12c119.35 25.36 236.66-50.82 262.03-170.16C553.48 238.6 477.3 121.3 357.96 95.93Z" />
                            <use
                                xlinkHref="#e"
                                stroke="#FFF"
                                strokeDasharray="92.52571105957031,2208"
                                strokeWidth="441.6"
                                mask="url(#r)"
                                transform="rotate(-144 311.58 311.58)"
                            />
                            <path d="M503.1 201.32C442.1 95.66 307 59.45 201.32 120.46c-105.66 61-141.87 196.12-80.86 301.78 61 105.67 196.12 141.87 301.78 80.86 105.67-61 141.87-196.11 80.86-301.78Z" />
                            <use
                                xlinkHref="#f"
                                stroke="#FFF"
                                strokeDasharray="92.52571105957031,2208"
                                strokeWidth="441.6"
                                mask="url(#s)"
                                transform="rotate(-96 311.8 311.8)"
                            />
                            <path d="M522.48 380.64c37.7-116.04-25.8-240.67-141.84-278.37-116.04-37.7-240.67 25.8-278.37 141.84-37.7 116.04 25.8 240.67 141.84 278.37 116.04 37.7 240.67-25.8 278.37-141.84Z" />
                            <use
                                xlinkHref="#g"
                                stroke="#FFF"
                                strokeDasharray="92.52571105957031,2208"
                                strokeWidth="441.6"
                                mask="url(#t)"
                                transform="rotate(-48 312 312)"
                            />
                            <path d="M401.53 513.5C513 463.87 563.13 333.28 513.5 221.82 463.87 110.36 333.28 60.23 221.82 109.86 110.36 159.48 60.23 290.07 109.86 401.53 159.48 513 290.07 563.13 401.53 513.5Z" />
                            <use xlinkHref="#h" stroke="#15D508" strokeDasharray="92.52571105957031,2208" strokeWidth="441.6" mask="url(#u)" />
                        </g>
                    </g>
                    <g mask="url(#m)">
                        <g transform="translate(10 10)">
                            <mask id="w" fill="#fff">
                                <use xlinkHref="#v" />
                            </mask>
                            <use xlinkHref="#v" fill="#D8D8D8" />
                            <g fillRule="nonzero" mask="url(#w)">
                                <path fill="#DA0000" d="m183.96 184.3.12 183.91a183.45 183.45 0 0 1-74.9-15.96l74.78-167.95Z" />
                                <path fill="#1A191F" d="m183.81 184.17-74.7 168.06A183.45 183.45 0 0 1 47.2 307.2L183.8 184.17Z" />
                                <path fill="#DA0000" d="M183.74 184.06 47.14 307.2A183.45 183.45 0 0 1 8.9 240.87l174.85-56.81Z" />
                                <path fill="#1A191F" d="M184.08 184.3 9.21 241.26a183.45 183.45 0 0 1-7.97-76.16l182.84 19.22Z" />
                                <path fill="#DA0000" d="M184.27 184.36 1.35 165.26a183.45 183.45 0 0 1 23.7-72.82l159.22 91.92Z" />
                                <path fill="#1A191F" d="M184 183.95 24.67 92.09a183.45 183.45 0 0 1 51.27-56.88L184 183.95Z" />
                                <path fill="#DA0000" d="M184.3 184.1 76.1 35.39a183.45 183.45 0 0 1 69.98-31.1L184.3 184.1Z" />
                                <path fill="#1A191F" d="M184.4 184.1 146.06 4.24c24.51-5.22 50.49-5.5 76.58.05L184.41 184.1Z" />
                                <path fill="#DA0000" d="M184.3 183.95 222.42 4.03a183.45 183.45 0 0 1 69.94 31.18L184.3 183.95Z" />
                                <path fill="#1A191F" d="M184.7 184.36 292.71 35.5a183.45 183.45 0 0 1 51.21 56.94L184.7 184.36Z" />
                                <path fill="#DA0000" d="M184.59 184.3 343.8 92.26a183.45 183.45 0 0 1 23.63 72.84l-182.84 19.22Z" />
                                <path fill="#1A191F" d="m184.22 184.06 182.9-19.34c2.63 24.92.2 50.78-8.05 76.15l-174.85-56.81Z" />
                                <path fill="#DA0000" d="m184.19 184.17 174.95 56.72a183.45 183.45 0 0 1-38.33 66.3L184.2 184.17Z" />
                                <path fill="#1A191F" d="m184.17 184.3 136.75 122.97a183.45 183.45 0 0 1-61.98 44.98L184.17 184.3Z" />
                                <path fill="#15D508" d="m184 184.25 74.9 167.86A183.35 183.35 0 0 1 184 368V184.25Z" />
                            </g>
                        </g>
                    </g>
                    <path
                        fill="url(#x)"
                        d="M194 10c101.62 0 184 82.38 184 184s-82.38 184-184 184S10 295.62 10 194 92.38 10 194 10Zm0 92a92 92 0 1 0 0 184 92 92 0 0 0 0-184Z"
                        mask="url(#m)"
                    />
                    <g fillRule="nonzero" mask="url(#m)">
                        <g transform="rotate(168 211.21 338.4)">
                            <use xlinkHref="#y" fill="#E7E7E7" />
                            <use xlinkHref="#y" fill="url(#z)" />
                        </g>
                        <g transform="translate(26.47 26.6)">
                            <use xlinkHref="#A" fill="#E7E7E7" />
                            <use xlinkHref="#A" fill="url(#B)" />
                        </g>
                        <g transform="rotate(120 311.35 266.56)">
                            <use xlinkHref="#C" fill="#E7E7E7" />
                            <use xlinkHref="#C" fill="url(#D)" />
                        </g>
                        <g transform="translate(26.47 26.6)">
                            <use xlinkHref="#E" fill="#E7E7E7" />
                            <use xlinkHref="#E" fill="url(#F)" />
                        </g>
                        <g transform="rotate(73 314.28 149.76)">
                            <use xlinkHref="#G" fill="#E7E7E7" />
                            <use xlinkHref="#G" fill="url(#H)" />
                        </g>
                        <g transform="translate(26.47 26.6)">
                            <use xlinkHref="#I" fill="#E7E7E7" />
                            <use xlinkHref="#I" fill="url(#J)" />
                        </g>
                        <g transform="rotate(23 178.92 99.89)">
                            <use xlinkHref="#K" fill="#E7E7E7" />
                            <use xlinkHref="#K" fill="url(#L)" />
                        </g>
                        <g transform="translate(26.47 26.6)">
                            <use xlinkHref="#M" fill="#E7E7E7" />
                            <use xlinkHref="#M" fill="url(#N)" />
                        </g>
                        <g transform="rotate(-23 181.2 -29.96)">
                            <use xlinkHref="#O" fill="#E7E7E7" />
                            <use xlinkHref="#O" fill="url(#P)" />
                        </g>
                        <g transform="translate(26.47 26.6)">
                            <use xlinkHref="#Q" fill="#E7E7E7" />
                            <use xlinkHref="#Q" fill="url(#R)" />
                        </g>
                        <g transform="rotate(-73 46.73 113.9)">
                            <use xlinkHref="#S" fill="#E7E7E7" />
                            <use xlinkHref="#S" fill="url(#T)" />
                        </g>
                        <g transform="rotate(-95 33.32 184.68)">
                            <use xlinkHref="#U" fill="#E7E7E7" />
                            <use xlinkHref="#U" fill="url(#V)" />
                        </g>
                        <g transform="rotate(-120 48.74 252.77)">
                            <use xlinkHref="#W" fill="#E7E7E7" />
                            <use xlinkHref="#W" fill="url(#X)" />
                        </g>
                        <g transform="rotate(-144 89.68 305.06)">
                            <use xlinkHref="#Y" fill="#E7E7E7" />
                            <use xlinkHref="#Y" fill="url(#Z)" />
                        </g>
                        <g transform="rotate(-168 148.96 335.48)">
                            <use xlinkHref="#aa" fill="#E7E7E7" />
                            <use xlinkHref="#aa" fill="url(#ab)" />
                        </g>
                    </g>
                    <g fill="#000" mask="url(#m)">
                        <g opacity=".8">
                            <g transform="translate(67 69)">
                                <use xlinkHref="#ad" filter="url(#ac)" />
                                <use xlinkHref="#ad" fillOpacity="0" />
                                <use xlinkHref="#ad" filter="url(#ae)" />
                            </g>
                            <g transform="rotate(46 159.63 164.99)">
                                <use xlinkHref="#ag" filter="url(#af)" />
                                <use xlinkHref="#ag" fillOpacity="0" />
                                <use xlinkHref="#ag" filter="url(#ah)" />
                            </g>
                            <g transform="rotate(96 238.12 201.15)">
                                <use xlinkHref="#aj" filter="url(#ai)" />
                                <use xlinkHref="#aj" fillOpacity="0" />
                                <use xlinkHref="#aj" filter="url(#ak)" />
                            </g>
                            <g transform="rotate(143 212.83 259.3)">
                                <use xlinkHref="#am" filter="url(#al)" />
                                <use xlinkHref="#am" fillOpacity="0" />
                                <use xlinkHref="#am" filter="url(#an)" />
                            </g>
                            <g transform="rotate(-145 107.26 237.23)">
                                <use xlinkHref="#ap" filter="url(#ao)" />
                                <use xlinkHref="#ap" fillOpacity="0" />
                                <use xlinkHref="#ap" filter="url(#aq)" />
                            </g>
                            <g transform="rotate(-96 82.25 140.82)">
                                <use xlinkHref="#as" filter="url(#ar)" />
                                <use xlinkHref="#as" fillOpacity="0" />
                                <use xlinkHref="#as" filter="url(#at)" />
                            </g>
                            <g transform="rotate(-48 156.2 10.95)">
                                <use xlinkHref="#av" filter="url(#au)" />
                                <use xlinkHref="#av" fillOpacity="0" />
                                <use xlinkHref="#av" filter="url(#aw)" />
                            </g>
                        </g>
                        <g opacity=".5">
                            <g transform="rotate(24 36.37 218.57)">
                                <use xlinkHref="#ay" filter="url(#ax)" />
                                <use xlinkHref="#ay" fillOpacity="0" />
                                <use xlinkHref="#ay" filter="url(#az)" />
                            </g>
                            <g transform="rotate(71 213.04 172.02)">
                                <use xlinkHref="#aB" filter="url(#aA)" />
                                <use xlinkHref="#aB" fillOpacity="0" />
                                <use xlinkHref="#aB" filter="url(#aC)" />
                            </g>
                            <g transform="rotate(119 233.3 232.28)">
                                <use xlinkHref="#aE" filter="url(#aD)" />
                                <use xlinkHref="#aE" fillOpacity="0" />
                                <use xlinkHref="#aE" filter="url(#aF)" />
                            </g>
                            <g transform="rotate(168 177.98 268.81)">
                                <use xlinkHref="#aH" filter="url(#aG)" />
                                <use xlinkHref="#aH" fillOpacity="0" />
                                <use xlinkHref="#aH" filter="url(#aI)" />
                            </g>
                            <g transform="rotate(-168 140.45 261.67)">
                                <use xlinkHref="#aK" filter="url(#aJ)" />
                                <use xlinkHref="#aK" fillOpacity="0" />
                                <use xlinkHref="#aK" filter="url(#aL)" />
                            </g>
                            <g transform="rotate(-120 84.91 192.67)">
                                <use xlinkHref="#aN" filter="url(#aM)" />
                                <use xlinkHref="#aN" fillOpacity="0" />
                                <use xlinkHref="#aN" filter="url(#aO)" />
                            </g>
                            <g transform="rotate(-72 104.4 77.42)">
                                <use xlinkHref="#aQ" filter="url(#aP)" />
                                <use xlinkHref="#aQ" fillOpacity="0" />
                                <use xlinkHref="#aQ" filter="url(#aR)" />
                            </g>
                            <g transform="rotate(-24 282.4 -101.35)">
                                <use xlinkHref="#aT" filter="url(#aS)" />
                                <use xlinkHref="#aT" fillOpacity="0" />
                                <use xlinkHref="#aT" filter="url(#aU)" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
